var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('pop-dialog', _vm._g(_vm._b({
    attrs: {
      "width": "90%",
      "height": "auto",
      "is-loc": "center"
    }
  }, 'pop-dialog', _vm.$attrs, false), _vm.$listeners), [_c('div', {
    staticClass: "pop-main-star-deposit"
  }, [_c('div', {
    staticClass: "adv-title"
  }, [_vm._v(" Deposit ")]), _c('div', {
    staticClass: "adv-content"
  }, _vm._l(_vm.amountList, function (item) {
    return _c('div', {
      staticClass: "adv-item",
      on: {
        "click": function ($event) {
          return _vm.toDoDeposit(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.theme}/ton-stars.png`),
        "alt": ""
      }
    }), _c('div', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(_vm._f("fmt_pre")(item)))])]);
  }), 0)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };